<ng-container *ngIf="block">
  <div class="row container-general h-100">
    <div class="col container-general__container-dropdown h-100">
      <div ngbDropdown (openChange)="viewCheckboxGroupForm = true" #myDrop="ngbDropdown" placement="center"
        class="d-inline-block w-100 container-general__container-dropdown__ngbdrop h-100">
        <!-- GENERAL -->
        <ng-container *ngIf="!isCorsiLaureaTutti">
          <button type="button"
          class="btn container-general__container-dropdown__ngbdrop__btn-custom w-100 d-flex align-items-center ls-label-large text-neutral-50 bg-neutral-A1 justify-content-between h-100"
          id="{{ 'dropdown-' + id }}" ngbDropdownToggle 
          [ngClass]="{'b-success': isValue, 'firstInput': firstInput, 'lastInput': lastInput, 'oneInput': firstInput && lastInput, 'otherInput': !firstInput && !lastInput}"
        >
          <ng-container *ngIf="!isCorsiLaureaTutti">
            <span class="truncate-custom" [innerHTML]="titleDropdown"></span>
            <i class="fa-solid fa-angle-down text-success" aria-hidden="true"></i>
          </ng-container>
          <ng-container *ngIf="isCorsiLaureaTutti">
            <img loading="lazy" class="me-2" src="./assets/images/icon_plus_search_course.svg" alt="icon plus | LUMSA">
            <span class="truncate-custom-key" [innerHTML]="titleDropdown"></span>
          </ng-container>
        </button>
        </ng-container>
        <!-- KEYWORD E PROFILI -->
        <ng-container *ngIf="isCorsiLaureaTutti">
          <button type="button"
          class="btn container-general__container-dropdown__ngbdrop__btn-custom w-100 d-flex align-items-center ls-label-large text-brand-40 text-uppercase bg-brand-95 btn-hover-cdl justify-content-center h-100"
          id="{{ 'dropdown-' + id }}" ngbDropdownToggle 
          [ngClass]="{'b-success': isValue, 'firstInput': firstInput, 'lastInput': lastInput, 'oneInput': firstInput && lastInput, 'otherInput': !firstInput && !lastInput}" 
          [ngStyle]="{'padding': isCorsiLaureaTutti ? '23px 14px' : '23px 16px'}"
        >
          <ng-container *ngIf="!isCorsiLaureaTutti">
            <span class="truncate-custom" [innerHTML]="titleDropdown"></span>
            <i class="fa-solid fa-angle-down text-success" aria-hidden="true"></i>
          </ng-container>
          <ng-container *ngIf="isCorsiLaureaTutti">
            <img loading="lazy" class="me-2" src="./assets/images/icon_plus_search_course.svg" alt="icon plus | LUMSA">
            <span class="truncate-custom-key ls-label-medium-semibold" [innerHTML]="titleDropdown"></span>
          </ng-container>
        </button>
        </ng-container>
        <div class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu" ngbDropdownMenu
          aria-labelledby="{{ 'dropdown-' + block.id }}">
          <div
            class="d-flex justify-content-between align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__header">
            <p class="m-0 ls-label-small-bold text-uppercase"
              [innerHTML]="block['label_' + helpersService.langCodeApi]"></p>
            <div class="cursor-pointer" (click)="$event.stopPropagation(); myDrop.close();">
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </div>
          </div>
          <form *ngIf="viewCheckboxGroupForm" [formGroup]="checkboxGroupForm"
            class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form">
            <div id="checkboxGroupForm{{id}}"
              class="d-flex flex-column justify-content-between container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox">
              <div
                class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general">
                <input *ngIf="block.id === 3" type="search" placeholder="Cerca e premi invio" [formControl]="typeahead"
                  aria-label="Cerca"
                  class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__search bg-light"
                  (keyup.enter)="suggest()">
                <div
                  class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box">
                  <ng-container *ngFor="let order of filteredArray | async; let i = index" >
                    <div
                      class="d-flex align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box__cont-label"
                      [ngClass]="{'text-custom': checkboxGroupForm.value.checkbox[i]}">
                      <label class="col-2" formArrayName="checkbox">
                        <input type="checkbox" [formControlName]="i">
                      </label>
                      <p class="m-0 col-10 ls-p" [innerHTML]="order.field_nome_frontend ? order.field_nome_frontend : order.name"></p>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="container-btn">
                <button type="button" class="container-btn__submit ls-label-small-semibold text-uppercase text-neutral-A1 bg-brand-40 w-100"
                  (click)="submit(); $event.stopPropagation(); myDrop.close();">{{"FIND_OUT" | translate}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>